var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMoney = function SvgIconMoney(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 8.375a3.625 3.625 0 1 0 0 7.25 3.625 3.625 0 0 0 0-7.25M10.375 12a1.625 1.625 0 1 1 3.25 0 1.625 1.625 0 0 1-3.25 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 5A1.75 1.75 0 0 0 .5 6.75v10.5c0 .966.784 1.75 1.75 1.75h19.5a1.75 1.75 0 0 0 1.75-1.75V6.75A1.75 1.75 0 0 0 21.75 5zm6.38 12h6.74l5.625-5-5.625-5H8.63l-5.625 5zM2.5 14.227V17h3.12zm0-4.454L5.62 7H2.5zm19 4.454V17h-3.12zM21.5 7h-3.12l3.12 2.773z"
  }))));
};
export default SvgIconMoney;